export default {"src":"/_next/static/media/managed-db.7491a2fc.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};